
























import Vue from 'vue';
import DvFilterPopover from '@/components/util/DvFilterPopover.vue';

export default Vue.extend({
    components: { DvFilterPopover },
    props: {
        group: { type: Array as () => number[], default: () => [] },
        skillGroup: { type: Array as () => number[], default: () => [] },
        globalSkillGroup: { type: Array as () => number[], default: () => [] },
    },
    computed: {
        activeCount(): number {
            return this.group.length + this.skillGroup.length + this.globalSkillGroup.length;
        },
    },
    methods: {
        first(v: number[]): string {
            return v.length ? String(v[0]) : '';
        },
        //  A cleared box means "no filter", which is [] -- NOT [0]. Number('')
        //  is 0, so the empty check has to come before the parse.
        emitOne(event: string, evt: Event) {
            const raw = (evt.target as HTMLInputElement).value.trim();
            if (raw === '') {
                this.$emit(event, []);
                return;
            }
            const n = Number(raw);
            this.$emit(event, isNaN(n) ? [] : [n]);
        },
        //  "Select all" is meaningless for free-text ids; the popover always
        //  renders both buttons, so this one is deliberately inert.
        noop() {
            return;
        },
        clearAll() {
            this.$emit('selectGroup', []);
            this.$emit('selectSkillGroup', []);
            this.$emit('selectGlobalSkillGroup', []);
        },
    },
});
